"use client";

import { useState, useEffect } from "react";
import { Swiper } from "react-vant";
import ProductItem from "@/components/global/ProductItem";
import hottestDealsApi from "@/service/modules/hottestDealsApi";
import type { ProductType } from "@/types/product";
import styles from "@/styles/hottest-deals/crazy-top-sellers.module.scss";

export default function CrazyTopSellers() {
  const [topSellersData, setTopSellersData] = useState<ProductType[]>([]);

  // 获取topSellers模块数据
  async function getTopSellerData() {
    try {
      const resData = await hottestDealsApi.getTopSeller();

      if (resData.data && resData.data.length) {
        // 整理图片
        resData.data.forEach((item: ProductType) => {
          item.imgUrl = item.filename || item.newThumbnail;
        });

        setTopSellersData(resData.data);
      }
    } catch (error) {
      console.log(`topSellers模块数据 `, error);
    }
  }

  useEffect(() => {
    // 获取topSellers模块数据
    getTopSellerData();
  }, []);

  // 将数组按每两个分组
  const groupProducts = (products: ProductType[], groupSize: number = 2): ProductType[][] => {
    const groups: ProductType[][] = [];
    for (let i = 0; i < products.length; i += groupSize) {
      groups.push(products.slice(i, i + groupSize));
    }
    return groups;
  };

  const groupedProducts = groupProducts(topSellersData, 2);

  // 只有当有数据时才渲染 Swiper
  if (!topSellersData || topSellersData.length === 0) {
    return null;
  }

  return (
    <div className={styles["comp-crazy-top-sellers"]}>
      <div className={styles["title"]}>BestDeals Top Sellers</div>
      <Swiper autoplay={4000} loop={false}>
        {groupedProducts.map((group, groupIndex) => (
          <Swiper.Item key={groupIndex}>
            <div className={styles["product-group"]}>
              {group.map((product) => (
                <ProductItem key={product.productID} product={product} />
              ))}
            </div>
          </Swiper.Item>
        ))}
      </Swiper>
    </div>
  );
}
